import {GET, POST} from "@/services/gateway";

const getBackedupItems = () => {
  return GET('dashboard/salesforce/backup-events');
}

const list = (data) => {
  return POST('dashboard/salesforce/backup-events', data);
}

const getBackupItems = () => {
  return GET('dashboard/salesforce/backup-items');
}

export {
  getBackedupItems,
  list,
  getBackupItems,
}
